<template>
  <div class="hover" v-if="player && !(cursor.y === 0 && cursor.x === 0)" :style="{ ...cursor, boxShadow: `0px 0px 30px 0px ${player.color}` }">
    <div v-if="player">
      {{ player.displayName }}, <span v-if="hover.lvl >= 0">Upgrade: {{ hover.lvl }}</span>
    </div>
    <!-- <pre>{{ player }}</pre> -->
  </div>
</template>

<script>
let cursor = {
  x: 0,
  y: 0,
  top: `0px`,
  left: `0px`,
  transform: `scale(1)`
}
window.addEventListener('mousemove', (evt) => {
  let y = `${evt.pageY + 30}px`
  let x = `${evt.pageX + 0}px`
  cursor.x = x
  cursor.y = y
  cursor.transform = `translate3d(${x}, ${y}, 0px)`;
})

export default {
  props: {
    activeCells: {
      required: true
    },
    players: {
      required: true
    },
    hover: {
      required: true
    }
  },
  data () {
    return {
      cursor
    }
  },
  watch: {
    cursor: {
      deep: true,
      handler () {
        this.$forceUpdate()
      }
    }
  },
  computed: {
    player () {
      return this.players.find(p => p.userID === this.hover.uid)
    },
    cellCounter () {
      // console.log(this.players.map(p => p.gameInfo.cellCore))
      return [...this.activeCells].filter(a => a.uid === this.hover.uid).length
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.hover{
  position: fixed;
  top: 0px;
  left: 0px;
  padding: 30px;
  background-color: rgba(255, 255, 255, 0.781);
  border-radius: 30px;
}
</style>
